import React, { useMemo } from "react";

// redux
import { shallowEqual, useSelector } from "react-redux";

// diğer
import CountUp from "react-countup";

const Widgets = ({ tabType }) => {
  const {
    serviceCommissionSummary,
    serviceCommissionSummaryLoading,
    couponSummary,
    couponSummaryLoading,
    primSummary,
    primSummaryLoading,
  } = useSelector(
    (state) => ({
      serviceCommissionSummary: state.company.serviceCommissionSummary,
      serviceCommissionSummaryLoading:
        state.company.serviceCommissionSummaryLoading,
      couponSummary: state.company.couponSummary,
      couponSummaryLoading: state.company.couponSummaryLoading,
      primSummary: state.company.primSummary,
      primSummaryLoading: state.company.primSummaryLoading,
    }),
    shallowEqual
  );

  const isLoading = useMemo(() => {
    switch (tabType) {
      case "coupon":
        return couponSummaryLoading;
      case "prim":
        return primSummaryLoading;
      default:
        return serviceCommissionSummaryLoading;
    }
  }, [
    tabType,
    couponSummaryLoading,
    primSummaryLoading,
    serviceCommissionSummaryLoading,
  ]);

  const widgetsData = useMemo(() => {
    let summaryData = {};
    let titles = {};

    switch (tabType) {
      case "coupon":
        summaryData = couponSummary;
        titles = {
          countLabel: "Toplam Kupon",
          totalLabel: "Toplam Hak Ediş",
          paidLabel: "Ödenen Hak Ediş",
          remainingLabel: "Kalan Hak Ediş",
        };
        break;
      case "prim":
        summaryData = primSummary;
        titles = {
          countLabel: "Toplam Kayıt",
          totalLabel: "Toplam Prim",
          paidLabel: "Ödenen Prim",
          remainingLabel: "Kalan Prim",
        };
        break;
      case "ciro":
      default:
        summaryData = serviceCommissionSummary;
        titles = {
          countLabel: "Toplam Servis",
          totalLabel: "Toplam Ciro Primi",
          paidLabel: "Ödenen Ciro Primi",
          remainingLabel: "Kalan Ciro Primi",
        };
        break;
    }

    const data = summaryData || {};

    return [
      {
        id: 1,
        label: titles.countLabel,
        icon: "ri-shopping-cart-2-line",
        counter: data.totalCount || 0,
        decimals: 0,
        prefix: "",
        suffix: "",
        bgColor: "bg-primary-subtle",
        iconColor: "text-primary",
      },
      {
        id: 2,
        label: titles.totalLabel,
        icon: "ri-money-dollar-circle-line",
        counter: data.totalEarnings || 0,
        decimals: 2,
        prefix: "₺",
        separator: ",",
        bgColor: "bg-success-subtle",
        iconColor: "text-success",
      },
      {
        id: 3,
        label: titles.paidLabel,
        icon: "ri-hand-coin-line",
        counter: data.paidEarnings || 0,
        decimals: 2,
        prefix: "₺",
        separator: ",",
        bgColor: "bg-info-subtle",
        iconColor: "text-info",
      },
      {
        id: 4,
        label: titles.remainingLabel,
        icon: "ri-wallet-3-line",
        counter: data.remainingEarnings || 0,
        decimals: 2,
        prefix: "₺",
        separator: ",",
        bgColor: "bg-warning-subtle",
        iconColor: "text-warning",
      },
    ];
  }, [tabType, serviceCommissionSummary, couponSummary, primSummary]);

  return (
    <React.Fragment>
      <div className="row g-4">
        {widgetsData.map((widget) => (
          <div className="col-xl-3 col-md-6" key={widget.id}>
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body p-4">
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1">
                    <h6 className="text-muted text-uppercase fs-13 fw-medium mb-2">
                      {widget.label}
                    </h6>
                    <h2 className="mb-0 fw-semibold fs-18">
                      {isLoading ? (
                        <div
                          className="spinner-border spinner-border-sm text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Yükleniyor...</span>
                        </div>
                      ) : (
                        <CountUp
                          key={widget.counter}
                          start={0}
                          prefix={widget.prefix}
                          suffix={widget.suffix}
                          separator={widget.separator}
                          end={parseFloat(widget.counter) || 0}
                          decimals={widget.decimals}
                          duration={0}
                        />
                      )}
                    </h2>
                  </div>
                  <div className="flex-shrink-0">
                    <div
                      className={`widget-icon-shape ${widget.bgColor} ${widget.iconColor}`}
                    >
                      <i className={`${widget.icon} fs-1`}></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
};

export default Widgets;
